import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isIOs } from '../../misc/selectors'
import { browserHistory, Link } from 'react-router'

const mapStateToProps = (state, ownProps) => {
  const { videos, me } = state

  return {
    isIOs: isIOs(state),
    me
  }
}

class FooterCTA extends Component {
  render() {
    return (
      <div className="footer-cta-pane">
        <span className="footer-text">Get started for free.</span>
        <div>
          <Link to="/signup"
            className="upload-button blue-button"
          >Sign up now</Link>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(FooterCTA)
